import {
  NestjsGetByIdRequest,
  NestjsGetListPageRequest,
} from 'nestjs-model-utility';
import { Home } from '../../domain/entity/home.entity';
import { HomePageFilterApiRoute } from '../api-route/home-page/home-page-filter.api';
import { HomePageByIdApiRoute } from '../api-route/home-page/home-page-byid.api';

export namespace HomeRequest {
  export class List extends NestjsGetListPageRequest<
    Home,
    true,
    typeof HomePageFilterApiRoute
  > {
    _api = HomePageFilterApiRoute;
    cache: true = true;
  }

  export class GetById extends NestjsGetByIdRequest<
    Home,
    typeof HomePageByIdApiRoute,
    true
  > {
    _api = HomePageByIdApiRoute;
    cache: true = true;
  }
}
